// extracted by mini-css-extract-plugin
module.exports = {"container":"card-module--container--37C2q","image":"card-module--image--31WtB","name":"card-module--name--cG0NO","country":"card-module--country--M9JMJ"};